var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 52,
    viewBox: "0 0 46.451 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_017-cube",
    "data-name": "017-cube",
    transform: "translate(-30 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M73.355,82v25.3l-18.581,7.963V91.29h-3.1v23.974L33.1,107.3V82H30v26.322a1.549,1.549,0,0,0,.939,1.423l21.677,9.29v0a1.532,1.532,0,0,0,1.219,0l21.677-9.29a1.549,1.549,0,0,0,.938-1.424V82Z",
    transform: "translate(0 -45.161)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M53.226,47.678a1.551,1.551,0,0,1-.61-.125l-21.677-9.29a1.549,1.549,0,0,1,0-2.847l21.677-9.29a1.551,1.551,0,0,1,1.22,0l21.677,9.29a1.549,1.549,0,0,1,0,2.847l-21.677,9.29a1.551,1.551,0,0,1-.61.125ZM35.479,36.839l17.747,7.606,17.747-7.606L53.226,29.233Z",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeApi);
export default __webpack_public_path__ + "static/media/knowledge_api.e80fcef1c81c5d3739fbacd5b92b31bc.svg";
export { ForwardRef as ReactComponent };